export default "__VITE_ASSET__BcHaYJHF__"